import KEY from "./Key";
import { defaultUserInfo } from "./type";

export const WebViewMessage = async (event, data) =>
  new Promise((resolve, reject) => {
    if (!window.ReactNativeWebView) {
      reject("No ReactNativeWebView object");
      return;
    }
    const reqId = Date.now(); // uuid로 구현해도 좋습니다.
    const TIMEOUT = 60000; // 60 second
    const timer = setTimeout(() => {
      /** android */
      document.removeEventListener("message", listener);
      /** ios */
      window.removeEventListener("message", listener);
      reject("TIMEOUT");
    }, TIMEOUT);
    const listener = (res) => {
      const {
        event: eventResult,
        data: listenerData,
        reqId: listenerReqId,
      } = JSON.parse(res.data);
      if (listenerReqId === reqId && eventResult === event + "_RESULT") {
        clearTimeout(timer);
        /** android */
        document.removeEventListener("message", listener);
        /** ios */
        window.removeEventListener("message", listener);
        resolve(listenerData);
      }
    };

    /** android */
    document.addEventListener("message", listener);
    /** ios */
    window.addEventListener("message", listener);
    window.ReactNativeWebView.postMessage(
      JSON.stringify({
        event,
        data,
        reqId,
      })
    );
  });

export const detectChildWindow = async function (childWindow, closeCallback) {
  const interval = window.setInterval(function () {
    try {
      if (childWindow == null || childWindow.closed) {
        window.clearInterval(interval);
        closeCallback(childWindow);
      }
    } catch (e) {
      console.error(e.message);
    }
  }, 1000);
  return childWindow;
};

export const autoConnect = async () => {
  const { BoxPrivateKey, BoxPublicKey } = KEY.MakeBoxKeypair();
  try {
    const data = await WebViewMessage("AUTO_CONNECT_WALLET", {
      boxPublicKey: BoxPublicKey,
    });
    let userInfo = defaultUserInfo;
    if (data.auto_connect) {
      userInfo = {
        address: data.address,
        new_address: data.new_address,
        is_authorized: data.is_authorized,
        id: data.id,
        nickname: data.nickname,
        profile_image: data.profile_image,
        whisper_image: data.whisper_image,
        description: data.description,
        kyc_status: data.kyc_status,
        kyc_application_id: data.kyc_application_id,
        token: JSON.parse(
          KEY.Decryption(
            data.encryptedToken,
            KEY.HexToByte(data.nonce),
            BoxPrivateKey,
            data.box_pub_key
          )
        ),
      };
    }
    return { isInWhipser: true, userInfo };
  } catch (e) {
    return { isInWhipser: false, userInfo: defaultUserInfo };
  }
};

export const connect = async () => {
  const { BoxPrivateKey, BoxPublicKey } = KEY.MakeBoxKeypair();
  const data = await WebViewMessage("CONNECT_WALLET", {
    boxPublicKey: BoxPublicKey,
  });
  const userInfo = {
    address: data.address,
    new_address: data.new_address,
    is_authorized: data.is_authorized,
    id: data.id,
    nickname: data.nickname,
    profile_image: data.profile_image,
    whisper_image: data.whisper_image,
    description: data.description,
    kyc_status: data.kyc_status,
    kyc_application_id: data.kyc_application_id,
    token: JSON.parse(
      KEY.Decryption(
        data.encryptedToken,
        KEY.HexToByte(data.nonce),
        BoxPrivateKey,
        data.box_pub_key
      )
    ),
  };
  return userInfo;
};

export const disconnect = async () => {
  const data = await WebViewMessage("DISCONNECT_WALLET", {});
  if (data) {
    return true;
  } else {
    return false;
  }
};

export const requestTransaction = async (signingData) => {
  const data = await WebViewMessage("REQUEST_TRANSACTION", {
    signature: signingData,
  });
  return data;
};

export const requestEasySwap = async (easySwapData) => {
  const data = await WebViewMessage("EASY_SWAP", { ...easySwapData });
  return data;
};
